import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardBody,
  CardHeader,
  ListGroup,
  ListGroupItem,
  Alert
} from 'reactstrap';
import Select from 'react-select';

const CustomerPersonnel = ({ pb, customerId, isEditing }) => {
  const [personnel, setPersonnel] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState({ show: false, type: '', message: '' });

  useEffect(() => {
    const fetchData = async () => {
      if (!customerId) {
        console.log('No customer ID provided');
        setLoading(false);
        return;
      }
  
      try {
        setLoading(true);
        
        // Fetch personnel list
        const allPersonnel = await pb.collection('personel').getFullList({
          sort: 'name'
        });
  
        // Fetch customer data
        const customer = await pb.collection('customers').getOne(customerId);
        
        setPersonnel(allPersonnel);
        setSelectedIds(customer.customer_contact || []);
      } catch (error) {
        console.error('Error fetching data:', error);
        // Handle specific error scenarios
        if (error.status === 404) {
          console.error('Customer not found');
        }
      } finally {
        setLoading(false);
      }
    };
  
    fetchData();
  }, [customerId, pb]);

  const handlePersonnelChange = async (selected) => {
    try {
      const selectedIds = selected ? selected.map(option => option.value) : [];
      await pb.collection('customers').update(customerId, {
        customer_contact: selectedIds
      });
      setSelectedIds(selectedIds);
      
      setAlert({
        show: true,
        type: 'success',
        message: 'Personel ataması güncellendi'
      });
      setTimeout(() => setAlert({ show: false }), 3000);
    } catch (error) {
      setAlert({
        show: true,
        type: 'danger',
        message: 'Güncelleme sırasında hata oluştu'
      });
    }
  };

  const options = personnel.map(person => ({
    value: person.id,
    label: `${person.name} ${person.surname} ${person.title ? `- ${person.title}` : ''}`
  }));

  const selectedPersonnel = personnel.filter(p => selectedIds.includes(p.id));

  if (loading) return <div>Loading...</div>;

  return (
    <Card>
      <CardHeader>
        <h5 className="card-title mb-0">Personel Listesi</h5>
      </CardHeader>
      <CardBody>
        {alert.show && (
          <Alert color={alert.type} className="mb-3">
            {alert.message}
          </Alert>
        )}

        {isEditing ? (
          <Select
            isMulti
            value={options.filter(option => selectedIds.includes(option.value))}
            options={options}
            onChange={(selected) => handlePersonnelChange(selected)}
            className="mb-3"
            placeholder="Personel seçin..."
          />
        ) : (
          <ListGroup>
            {selectedPersonnel.length > 0 ? (
              selectedPersonnel.map(person => (
                <ListGroupItem key={person.id} className="d-flex justify-content-between align-items-center">
                  <div>
                    <h6 className="mb-0">{person.name} {person.surname}</h6>
                    {person.title && <small className="text-muted">{person.title}</small>}
                  </div>
                  {person.email && (
                    <small className="text-primary">{person.email}</small>
                  )}
                </ListGroupItem>
              ))
            ) : (
              <ListGroupItem className="text-center text-muted">
                Atanmış personel bulunmuyor
              </ListGroupItem>
            )}
          </ListGroup>
        )}
      </CardBody>
    </Card>
  );
};

CustomerPersonnel.propTypes = {
  pb: PropTypes.object.isRequired,
  customerId: PropTypes.string.isRequired,
  isEditing: PropTypes.bool.isRequired
};

export default CustomerPersonnel;